import { FunctionFactory } from "survey-core";
import { determineHandInDateTime } from "../helpers/determineHandInDateTime";
import { combineDateAndTime } from "../helpers/combineDateAndTime";
import { pick } from "../helpers/pick";

export const registerFunctions = () => {
  FunctionFactory.Instance.register("determineHandInDateTime", (params) => {
    return determineHandInDateTime(params);
  });

  FunctionFactory.Instance.register("combineDateAndTime", (params) => {
    return combineDateAndTime(params);
  });

  FunctionFactory.Instance.register("pick", pick);
};
